<table class="table">
  <ng-container *ngIf="isColaborator || subsidiary; else storeView">
    <!-- Aquí iria la vista de productos por branch -->
  </ng-container>
  <ng-template #storeView>
    <thead>
      <th>Estado</th>
      <th>Nombre</th>
      <th>Sku</th>
      <th>Categoría</th>
      <th *ngIf="isV2">Imagen Principal</th> 
    </thead>
    <tbody>
      <tr *ngFor="let item of products" >
        <td>
          <div *ngIf="item.status === 'ACTIVE'" class="active-container">
            <p>ACTIVO</p>
          </div>
          <div *ngIf="item.status === 'INACTIVE'" class="inactive-container">
            <p>INACTIVO</p>
          </div>
        </td>
        <td>
          {{item.name}}
        </td>
        <td>
          {{item.sku}}
        </td>
        <td>
          {{item?.categoryName}}
        </td>
        <td *ngIf="isV2">
          <img *ngIf="item.imageUrl; else noImage" class="logo" [src]="item.imageUrl" />
          <ng-template #noImage>
            <img class="logo" src="assets/images/no-product-image.jpeg">
          </ng-template>
        </td>
        <td>
          <div class="options opt" *ngIf="showOptions">
            <img #imageElement src="assets/images/ico-options.svg" (click)="toggleOptions(imageElement)" class="opt">
            <div class="box d-none opt">
              <p class="opt" (click)="editar(item.id)">Editar producto</p>
              <p 
              *ngIf="item.isBundle" 
              class="opt" 
              (click)="gestionarProductos(item.id)"
            >
              Agregar componentes
            </p>
              <p 
              *ngIf="!isV2" 
              class="opt" 
              (click)="gestionarSku(item.id)"
            >
              Gestion de SKU
            </p>
            </div>
          </div>
        </td>
      </tr>
    </tbody>

  </ng-template>
</table>